(function () {
  if (window.__mailupSignup) return;
  window.__mailupSignup = true;

  var ENDPOINT = 'https://g5h6g.mailupclient.com/frontend/subscribe.aspx';
  var LIST = '32';
  var APGROUP = '152';
  var KEY = 'mailup_subscribed';
  var GROUPS = { it: { lang: '128', site: '150' }, en: { lang: '131', site: '151' } };

  function isDone() { try { return window.localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function remember() { try { window.localStorage.setItem(KEY, '1'); } catch (e) {} }

  function init(root) {
    if (root.__mu) return;
    root.__mu = true;
    var form = root.querySelector('[data-mailup-form]');
    var ok = root.querySelector('[data-success]');
    var err = root.querySelector('[data-error]');
    var btn = root.querySelector('[data-submit]');
    var intro = root.querySelector('[data-intro]');
    var inner = root.closest('.popup__inner');
    var popupText = inner ? inner.querySelector('.popup__text') : null;
    var copy = root.querySelector('[data-copy]');
    var codeEl = root.querySelector('[data-code-text]');
    var d = root.dataset;
    if (!form) return;

    function fail(msg) { err.textContent = msg || ''; err.hidden = !msg; }
    function success() { remember(); form.hidden = true; if (intro) intro.hidden = true; if (popupText) popupText.hidden = true; ok.hidden = false; }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      fail('');
      var email = form.elements.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { fail(d.msgEmail); form.elements.email.focus(); return; }
      if (!form.elements.consent.checked) { fail(d.msgConsent); return; }
      if (form.elements.website.value) { success(); return; }
      var picked = form.querySelector('input[name=group]:checked');
      var g = picked && picked.value === '131' ? GROUPS.en : GROUPS.it;
      var label = btn.textContent;
      var body = new URLSearchParams();
      body.append('list', LIST);
      body.append('apgroup', APGROUP);
      body.append('email', email);
      body.append('group', g.lang);
      body.append('group', g.site);
      body.append('Submit', 'Invia');
      btn.disabled = true;
      btn.textContent = d.msgSending;
      fetch(ENDPOINT, { method: 'POST', mode: 'no-cors', credentials: 'omit', body: body })
        .then(success, function () { fail(d.msgError); })
        .then(function () { btn.disabled = false; btn.textContent = label; });
    });

    if (copy) {
      copy.addEventListener('click', function () {
        var code = d.code;
        var done = function () {
          copy.textContent = d.msgCopied;
          setTimeout(function () { copy.textContent = d.msgCopy; }, 2000);
        };
        var fallback = function () {
          var range = document.createRange();
          range.selectNodeContents(codeEl);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          try { document.execCommand('copy'); done(); } catch (x) {}
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, fallback);
        } else {
          fallback();
        }
      });
    }
  }

  function boot() {
    if (isDone()) {
      var promos = document.querySelectorAll('[data-large-promo]');
      for (var i = 0; i < promos.length; i++) {
        if (promos[i].querySelector('[data-mailup-signup]')) promos[i].parentNode.removeChild(promos[i]);
      }
    }
    var all = document.querySelectorAll('[data-mailup-signup]');
    for (var j = 0; j < all.length; j++) init(all[j]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
